import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isString} from 'lodash';
import {scrollFromFooterOnFocus} from 'shared/scroll-on-focus';

export default class BaseStep extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    stepHeader: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]).isRequired,
    subHeader: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]),
    disclaimer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    ]),
    lateSeniorSignup: PropTypes.bool,
    className: PropTypes.string,
    required: PropTypes.bool,
    pageTitle: PropTypes.string,
    testId: PropTypes.string,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    scrollFromFooterOnFocus(150, 'input, select');
    const {pageTitle, stepHeader} = this.props;

    let title;

    if (pageTitle) {
      title = pageTitle;
    } else if (isString(stepHeader)) {
      title = stepHeader;
    } else {
      title = 'Tell us about yourself - Raise Me';
    }

    document.title = title;
  }

  render() {
    const {
      children,
      stepHeader,
      subHeader,
      disclaimer,
      className,
      required,
      lateSeniorSignup,
      testId,
    } = this.props;

    return (
      <div className={classnames('registration-step', className)} data-testid={testId}>
        <div className="step-header-wrapper">
          <h1 id="stepHeader" className="step-header">
            {stepHeader}
            {required && <span>*</span>}
          </h1>
          {lateSeniorSignup && (
            <div className="late-senior-signup-info">
              <p>
                <i className="rm rm-info-circle-r" aria-hidden="true"></i>&nbsp;Raise Me lets you
                earn scholarships from colleges before you even apply; as a result, many of our
                partner colleges’ earning deadlines have passed. If you’ve already applied and been
                accepted to your school of choice, then Raise Me is no longer the right place to
                earn from that school.
              </p>
            </div>
          )}
          {subHeader && <h2 className="step-sub-header">{subHeader}</h2>}
          {disclaimer && <p className="step-disclaimer">{disclaimer}</p>}
        </div>
        <div className="form-container">{children}</div>
      </div>
    );
  }
}
